<div class="campanha-cliente-visualizacao-modo">
    <div class="btn-group" role="group">
        <button *ngFor="let visualizacaoModo of visualizacoesModos"
            type="button"
            class="btn btn-light"
            [class.active]="visualizacaoModo.id === ngModel"
            (click)="onChange(visualizacaoModo)">
            <i [class]="visualizacaoModo.iconClass" *ngIf="visualizacaoModo.iconClass"></i>                                       
            {{visualizacaoModo.nome}}
        </button>
    </div>         
</div>